import { Component , OnInit} from '@angular/core';
import { Globals, PropertyDetail } from './shared/globals/globals';
import packageJson from '../../package.json';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from './shared/services/backend/backend.service';
import { TeiasoftLoaderService } from './shared/services/teiasoft-bucket/teiasoft-loader.service';
import { UserLogged } from './shared/models/data/userLogged.model';
import { UtilsService } from './shared/services/utils/utils.service';
import { TeiasoftOdataService } from './shared/services/teiasoft-bucket/teiasoft-odata.service';
import { TeiasoftToasterService } from './shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { IMenu } from './shared/teiasoft-bucket/teiasoft-header/teiasoft-header.component';
import { UserConfiguration } from './shared/models/data/userConfiguration.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit{
  title = 'quotation-tool';
  checkObjectTimerId: any;
  
  loadingTranslations : boolean = true;
  configurationLoadCompleted: boolean = false;

  constructor(public globals: Globals, private translateService: TranslateService, private router: Router, private activatedRoute: ActivatedRoute,
    private backendService: BackendService, private teiasoftLoader: TeiasoftLoaderService, private utilsService: UtilsService, 
    private oDataService: TeiasoftOdataService, private teiasoftToaster: TeiasoftToasterService, private translate: TranslateService){
      this.globals.theme = "silver";
      this.globals.isDesktop = !this.getDevice();
      this.globals.appVersion = "App Version: " + packageJson.version + " (beta-dev)";
      this.globals.propertyDetail = new PropertyDetail();
      this.globals.propertyDetail!.showInfo = false;
      this.globals.propertyDetail!.infoText = "";
      this.globals.propertyDetail!.showFooter = true;
      this.globals.cntPageH = window.innerHeight - (window.innerHeight*0.08) - (this.globals.isDesktop! ? (window.innerHeight*0.16) : (window.innerHeight*0.10)); 
      this.globals.isMock = false;
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params["isMock"]) {
          this.globals.isMock = params["isMock"] == 'true' ? true : false;
        } else {
          this.globals.isMock = false;
        }
      });
  }

  ngOnInit(): void {
    this.hydrateUserSessionFromStorage();
    this.loadingTranslations = true;
    this.utilsService.setLanguageTranslateAndDateFormat().subscribe( () => {
      this.loadingTranslations = false;
    });

    this.utilsService.getApiUrl().then(() => this.configurationLoadCompleted = true)
    //this.setLanguangeAndTranslate();
    /* if (this.checkObjectTimerId == undefined){
      this.checkObjectTimerId = setInterval(() => this.checkSessionObjects(), 2000);
    } */
  }

  
  /* METHODS */
  getDevice(): boolean{
    const userAgent: string = navigator.userAgent || navigator.vendor ; //|| window.opera
    const isMobileDevice = (): boolean => {
      const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i]
      return regexs.some((b) => userAgent.match(b))
    }
    const isTabletDevice = (): boolean => {
      const regex = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/
      return regex.test(userAgent.toLowerCase())
    }
    const isDesktopDevice = (): boolean => !isMobileDevice() && !isTabletDevice();
     if (isMobileDevice()) 
      return true;
    else
      return false;
  }

  logoutMe(){
    this.teiasoftLoader.start();
    this.backendService.logoutUser().subscribe(res => {
      this.teiasoftLoader.stop();
      this.globals.userLogged = new UserLogged();
      this.utilsService.clearStorage();
      clearInterval(this.checkObjectTimerId);
      this.router.navigate(["/login"]);
    });
  }

  updateUserConfiguration(){
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(res => {
      this.utilsService.setLanguageTranslateAndDateFormat();
      // HI - 7/12/2023 - Rif. MQF-03 - Commentato
      // this.teiasoftToaster.show("success", this.translateService.instant("commons.success")); 
      // END MQF-03
    });
  }

  checkSessionObjects(){
    let _selects: string[] = new Array();
    if (sessionStorage.getItem("TS-SELECT-LIST")){
      _selects = sessionStorage.getItem("TS-SELECT-LIST")!.split(",");
      let _duplicate: string[] = new Array();
      _duplicate = _selects.filter((item, index) => _selects.indexOf(item) != index);
      if (_duplicate.length > 0)
        console.log("[QuoteTool] Found duplicates in SelectList", _duplicate);
    }

 }

  /* EVENTS */
  onMenuClick(item: IMenu){
    if (!item) return;
    if (item.page === 'logout') {
      this.logoutMe();
      return;
    }
    if (item.action === 'openInfoUrl' || item.page === 'info-url') {
      this.openInfoUrl();
      return;
    }
    this.router.navigate(["/" + item.page]);
  }

  private openInfoUrl() {
    const newTab = window.open('', '_blank');
    if (newTab) {
      newTab.opener = null;
    }

    this.backendService.getInfoUrl().subscribe({
      next: res => {
        const infoUrl = res?.infoUrl;
        if (!infoUrl) {
          if (newTab) newTab.close();
          this.teiasoftToaster.show("error", this.translate.instant("commons.error"));
          return;
        }

        if (newTab) {
          newTab.location.href = infoUrl;
        } else {
          window.open(infoUrl, '_blank', 'noopener,noreferrer');
        }
      },
      error: () => {
        if (newTab) newTab.close();
        this.teiasoftToaster.show("error", this.translate.instant("commons.error"));
      }
    });
  }
  
  onChangeUserSettings(evt:any){
    this.updateUserConfiguration();
  }

  private hydrateUserSessionFromStorage(): void {
    if (this.globals.userLogged) {
      return;
    }

    const storedUser = localStorage.getItem('userLogged');
    if (!storedUser) {
      return;
    }

    try {
      const userLogged = Object.assign(new UserLogged(), JSON.parse(storedUser));
      this.globals.userLogged = userLogged;

      const rawLanguage = userLogged.language?.toString().trim().toLowerCase();
      if (rawLanguage) {
        userLogged.language = rawLanguage;
      }

      if (userLogged.configuration) {
        const configuration = JSON.parse(userLogged.configuration) as UserConfiguration;
        if (configuration?.theme) {
          this.globals.theme = configuration.theme;
        }
      }
    } catch {
      this.globals.userLogged = undefined;
    }
  }
}
